import Gun from "gun";
import { default as SEA } from "gun/sea.js";
export { Gun, SEA };
